import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import theme from '../../../../theme';
import { BLACK, FEED_BACK, PRIMARY_COLOR, PRIMARY_PURPLE } from '../../../../theme/colorConstants';
import { epochToDateInReadableFormat, epochToDayOfWeek } from '../../../../utils';
import CheckBox from '../../../CheckBox/CheckBox';

import styles from './mapFiltersStyles';

const MapFilters = ({ title = '', date, list = [], onChange, onClose }) => {
  const scrollBarStyles = {
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: PRIMARY_COLOR[30],
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: PRIMARY_COLOR[50],
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: PRIMARY_COLOR[80],
    },
  };

  return (
    <Grid
      container
      direction="column"
      sx={{ height: '100%', width: '430px', backgroundColor: styles?.bgColor }}
      data-testid="mocked-map-filters-sidebar"
    >
      <Grid
        container
        justifyContent="flex-end"
        sx={{
          width: `100%`,
          top: 0,
          padding: '4px',
        }}
      >
        <IconButton sx={{ color: styles?.iconButtonColor }} aria-label="close" onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      </Grid>
      <Grid container sx={{ padding: theme.spacing(0, 4, 0, 4) }}>
        {title && (
          <Typography
            sx={{
              width: '100%',
              marginBottom: '8px',
              color: styles?.title.fontColor,
              fontSize: styles?.title.fontSize,
              fontFamily: styles?.title.fontFamily,
            }}
          >
            {epochToDayOfWeek(date)} {epochToDateInReadableFormat(date)}
          </Typography>
        )}

        <Typography
          sx={{
            width: '100%',
            marginBottom: '8px',
            color: styles?.title.fontColor,
            fontSize: styles?.title.fontSize,
            fontFamily: styles?.title.fontFamily,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            width: '100%',
            marginBottom: '8px',
            color: styles?.infoText.fontColor,
            fontSize: styles?.infoText.fontSize,
            fontFamily: styles?.infoText.fontFamily,
          }}
        >
          {LanguageConverterV2('map.markerColorInfo')}
        </Typography>
      </Grid>
      <Grid
        item
        container
        xs
        sx={{
          padding: theme.spacing(0, 4, 3, 4),
        }}
        justifyContent="flex-start"
        overflow="auto"
        direction="column"
      >
        <Grid
          container
          overflow="auto"
          direction="row"
          sx={{ border: `1px solid ${BLACK[40]}}`, ...scrollBarStyles }}
        >
          <Grid sx={{ padding: '16px' }}>
            {list.length === 0 && (
              <Typography
                sx={{
                  color: styles?.noDataText.fontColor,
                  fontSize: styles?.noDataText.fontSize,
                  fontFamily: styles?.noDataText.fontFamily,
                }}
              >
                {LanguageConverterV2('map.noCoordinates')}
              </Typography>
            )}

            {list?.map((item) => (
              <Grid container key={item?._id}>
                <CheckBox
                  checked={item?.checked}
                  sx={{
                    '& .MuiCheckbox-root': {
                      color: item?.isSuspicious ? FEED_BACK.RED_75 : PRIMARY_PURPLE[40],
                    },
                    '& .MuiFormControlLabel-label': {
                      color: styles?.checkbox?.fontColor,
                      fontSize: styles?.checkbox?.fontSize,
                      fontFamily: styles?.checkbox?.fontFamily,
                    },
                  }}
                  label={item.name}
                  name={item?._id}
                  onChange={onChange}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

MapFilters.propTypes = {
  title: PropTypes.string,
  date: PropTypes.number,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
      radius: PropTypes.number,
    })
  ),
  onChange: PropTypes.func,
  onClose: PropTypes.func,
};

export default MapFilters;
